<template>
    <div class="wxsub">
        <div class="tip">绑定成功</div>
    </div>
</template>
<script>
    import { Toast } from 'vant';
    export default {
        data() {
            return {
                
            }
        },
        mounted() {
           
        },
        methods: {
            
        }
    }
</script>
<style lang="scss">
    .wxsub {
        width: 100%;
        height: 100vh;
        position: relative;
        .tip {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 30px;
        }
    }
</style>
